/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const $page = $( '#gform_page_' + formId + '_' + currentPage );

        if ( $page.hasClass( 'mm-page--career-interest' ) ) {
          const fieldInterest = $( '.mm-field--field-interest input:checked' ).val();
          const taxData = JSON.parse( $( '#mm-interest-career-data' ).text() || '{}' );
          const validPostIds = Object.values( taxData[fieldInterest] || {} ).map( String );

          $page.find( '.gchoice' ).each( function( index, val ) {
            const value = String( $( val ).find( 'input' ).val() );

            if ( validPostIds.includes( value ) || value == '__other__' ) {
              $( val ).removeAttr( 'style' );
            } else {
              $( val ).hide();
              $( val ).find( 'input' ).prop( 'checked', false );
            }
          } );
        }
      } );

      $( document ).on( 'click', '.llgq-current-page.llgq-radio-page input[type="radio"]:checked ~ label', function() {
        $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
      } );

      $( '.splide--major-match' ).each( function( key, component ) {
        const splide = new Splide( component, {
          pagination: false,
          perPage: 3,
          perMove: 1,
          gap: '32px',
          keyboard: true,
          breakpoints: {
            1270: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        splide.mount();

        $( window ).on( 'resize', function() {
          if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
            $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
          } else {
            $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
          }
        } );

        if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
          $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
        } else {
          $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'major-match', COMPONENT );
} )( app );
